import { render, staticRenderFns } from "./order-details.component.vue?vue&type=template&id=361bae23&scoped=true&"
import script from "./order-details.component.ts?vue&type=script&lang=ts&"
export * from "./order-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-details.component.scss?vue&type=style&index=0&id=361bae23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361bae23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
